export const DOWNLOAD_DATA = 'DOWNLOAD_DATA';
export const DOWNLOAD_CXM = 'DOWNLOAD_CXM';